import { combineReducers } from "redux";
import deleteIncomeUnitReducer from "./deleteIncomeUnitReducer";
import getincomeUnitReducer from "./getIncomeUnitReducer";
import getTenantSummaryReducer from "./getTenantSummaryReducer";
import getApartmentTenantSummaryReducer from "./getApartmentTenantSummaryReducer";
import updateUnitReducer from "./updateUnitReducer";
import createUnitReducer from "./createUnitReducer";
import getIndependentLivingReducer from "./getIndependentLivingReducer";
import getMemoryCareReducer from "./getMemoryCareReducer";
import getAssistedLivingReducer from "./getAssistedLivingReducer";
import getPreviousTenantSummaryReducer from "./getPreviousTenantSummaryReducer";
import getFullTenantSummaryReducer from "./getFullTenantSummaryReducer";
import getUnitsReducer from "./getUnitsReducer";
import rollDownUnitReducer from "./rollDownUnitReducer";

const incomeUnitReducer = combineReducers({
    getIncomeUnit: getincomeUnitReducer,
    deleteIncomeUnit: deleteIncomeUnitReducer,
    getTenantSummary: getTenantSummaryReducer,
    getIndependentLiving: getIndependentLivingReducer,
    getMemoryCare: getMemoryCareReducer,
    getAssistedLiving: getAssistedLivingReducer,
    getApartmentTenantSummary: getApartmentTenantSummaryReducer,
    putIncomeUnit: updateUnitReducer,
    postIncomeUnit: createUnitReducer,
    getPreviousTenantSummary: getPreviousTenantSummaryReducer,
    getFullTenantSummary: getFullTenantSummaryReducer,
    getUnits: getUnitsReducer,
    rollDownUnits: rollDownUnitReducer
});

export default incomeUnitReducer;